const getComponentName = (target) => {
    if (typeof target === 'string') {
        return target;
    }
    // React
    if (target && typeof target === 'object' && 'name' in target && target.name) {
        return target.name;
    }
    // Stencil
    if (target && typeof target === 'object' && 'tagName' in target && target.tagName) {
        return target.tagName.toLowerCase();
    }
    return 'Unknown Component';
};
const _log = (type, msg) => {
};
// Wrapped convenience log methods
const konsole = {
    warn: {
        prop: (ctor, propName, propValue, msg = '') => _log('warn', `*${getComponentName(ctor)}*: invalid value \`${propValue}\` for \`${propName}\`! ${msg}`),
        component: (componentConstructor, msg = '') => _log('warn', `*${getComponentName(componentConstructor)}*: ${msg}`),
        deprecation: (ctor, name, msg = '') => _log('warn', `*${getComponentName(ctor)}*: \`${name}\` is deprecated. ${msg}`),
        rename: (oldName, newName) => _log(),
        msg: (ctor, msg = '') => _log('warn', `*${getComponentName(ctor)}*: ${msg}`),
    }};

export { konsole as k };
